import { Header, Page, Toolbox } from 'redesign';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DocumentsTableProvider } from './table/documents-table';
import { DocumentPageToolbox } from './documents-page-toolbox';

export const DocumentsPage = () => {
  const { t } = useTranslation('hq-screen-specific');
  return (
    <Page
      header={<Header titleText={t('document_check.page_title')} />}
      toolbox={
        <Toolbox alignCenter={true}>
          <DocumentPageToolbox />
        </Toolbox>
      }
    >
      <Box width="100%">
        <DocumentsTableProvider />
      </Box>
    </Page>
  );
};
